// extracted by mini-css-extract-plugin
export default {"userpic":"lsf-userpic","userpic__username":"lsf-userpic__username"};
    if(module.hot) {
      // 1637785521798
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  